import React from 'react'

function StepToDownload() {
    return (
        <div className='py-10 border-t-2 rounded-lg my-10 p-4'>
            <h2 className='text-blue-600 text-center text-4xl'>Steps to Download</h2>

            <p className='my-8'>
                To ensure you make the most of your discount, follow these simple steps. Be sure to read all the information provided above before proceeding.
            </p>


            <h3 className="text-2xl font-semibold mb-2">Step 1: Review the Information</h3>
            <p className="mb-4">Before diving into the download and installation process, carefully review all the information provided in the blog or offer. Understand the terms and conditions associated with the coupon code and the software you{"'"}re about to download.</p>

            <h3 className="text-2xl font-semibold mb-2">Step 2: Check for Direct Software Link</h3>
            <p className="mb-4">In some cases, the blog or offer might provide a direct link to the software download page. If such a link is available, click on it. Some software packages come with a preattached license, meaning you won{"'"}t need to apply the coupon separately.</p>

            <h4 className="text-md font-semibold mb-2">Case 1: Preattached License</h4>
            <p className="mb-4">a) If the software comes with a preattached license, simply download the software from the provided link.<br />
                b) Install the software on your computer following the installation instructions.<br />
                c) Once the installation is complete, run the software.<br />
                d) Your software will automatically be upgraded to the premium or paid version without the need to apply the coupon separately.</p>

            <h4 className="text-md font-semibold mb-2">Case 2: Coupon Code Required</h4>
            <p className="mb-4">If the software doesn{"'"}t come with a preattached license, follow these steps:<br />
                a) <b>Check the Blog for Coupon Codes </b><br />
                - Review the blog or offer for any provided coupon codes. There might be multiple coupons available, so choose the one that best suits your needs.<br />
                b) <b>Download the Software</b><br />
                - Use the link provided in the blog to download the software. This link should direct you to the official download page of the software.<br />
                c)<b> Install the Software</b><br />
                - After the download is complete, follow the installation instructions to install the software on your computer.<br />
                d) <b>Sign Up or Log In</b><br />
                - In most cases, you{"'"}ll need to create an account or log in to your existing account associated with the software.<br />
                e) <b>Apply the Coupon</b><br />
                - Locate the section where you can enter or apply the coupon code within the software. This is typically found in the settings or account section.<br />
                f) <b>Avail Premium Features</b><br />
                - Once you{"'"}ve successfully applied the coupon code, the premium features of the software will be unlocked, and you{"'"}ll have access to all the benefits of the paid version.</p>

        </div>
    )
}

export default StepToDownload